var geoposition = null;
function XamarinFunctionLocation(latlon) {
  console.log(latlon);

  if (latlon && latlon != "" && latlon.length > 0) {
    var latitud = latlon.split(",")[0];
    var longitud = latlon.split(",")[1];
    var degrees = latlon.split(',')[2].split('|')[0];
    var velocity = latlon.split("|")[1];
    var metres = latlon.split("|")[2];
    var last = latlon.split("|")[3];
    geoposition = {
      lat: Number(latitud), lng: Number(longitud), degrees: Number(degrees),
      velocity: Number(velocity), metres: Number(metres), last: String(last),
    };
  } else {
    geoposition = null;
  }
}

var deviceId = null;
function XamarinFunctionDeviceId(id) {
  deviceId = id;
  console.log(id);
  return deviceId;
}

var tokenOS = null;
function XamarinFunctionTokenOS(token) {
  console.log(token);
  tokenOS = token;
  if (window.onTokenOSReady) {
    window.onTokenOSReady(token);
  }
}

var appVersion = null;
function XamarinFunctionAppVersion(version) { 
  if (version === null || version === undefined || String(version).trim() === "") {
    return;
  }
  appVersion = String(version).trim();
  if (window.onAppVersionReady) {
    window.onAppVersionReady(appVersion);
  }
}

var notificationReceived = null;
function XamarinFunctionNotificationReceived(data) {
  console.log(data);
  notificationReceived = fromBase64Json(data);
}

function fromBase64Json(encoded) {
  const json = atob(encoded);
  const obj = JSON.parse(json);
  return obj;
}

function XamarinFunctionPermissionsNotifications(acceptNot) {
  return acceptNot;
}

function XamarinFunctionPermissionsLocations(acceptLoc) {
  return acceptLoc;
}

function OpenLink(url) {
  if (window.Xamarin && typeof window.Xamarin.InvokeDisplayJSText === 'function') {
    window.Xamarin.InvokeDisplayJSText(url);
    return;
  }

  if (
    window.webkit &&
    window.webkit.messageHandlers &&
    window.webkit.messageHandlers.InvokeDisplayJSText
  ) {
    window.webkit.messageHandlers.InvokeDisplayJSText.postMessage(url);
    return;
  }
  window.open(url, '_blank');
}